export default __webpack_public_path__ + "static/media/backgroundVideo.c786c66b.mp4";